import { GlobalOrderResponse } from '@/data/api/model/orders/globalOrdersDto';
import { globalOrderResponseToGlobalOrderItemUi } from '@/hooks/order/useGetGlobalDetailOrders/globalOrderMapper';
import { orderDetailResponseToSelectedOrderDetails } from '@/hooks/order/useGetGlobalDetailOrders/mapper';
import { useGetGlobalOrders } from '@/hooks/order/useGetGlobalOrders';
import { responseToPagingUi } from '@/hooks/pagingMapper';
import { useEffect, useRef, useState } from 'react';
import { useImmer } from 'use-immer';
import {
  GlobalOrderItemUi,
  GlobalOrdersUi,
  initialState,
} from './GlobalOrdersUi';

export function useGlobalOrdersViewController() {
  const [uiState, setUiState] = useImmer<GlobalOrdersUi>(initialState);
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading } = useGetGlobalOrders(currentPage);
  const responseRef = useRef<GlobalOrderResponse[]>(undefined);

  useEffect(() => {
    setUiState((draft) => {
      draft.isLoading = isLoading;
      if (draft.isLoading) {
        draft.paging = undefined;
        draft.items = [];
      }
    });
  }, [isLoading]);

  useEffect(() => {
    if (!data) return;
    responseRef.current = data.data;
    setUiState((draft) => {
      draft.paging = responseToPagingUi(data);
      draft.items = data.data.map(globalOrderResponseToGlobalOrderItemUi);
    });
  }, [data]);

  const onOrderClicked = (uiItem: GlobalOrderItemUi) => {
    const orderDetails = responseRef.current?.find(
      (order) => order.order_id === uiItem.id
    )?.details;
    if (!orderDetails) return;
    setUiState((draft) => {
      draft.selectedOrder = {
        details: orderDetailResponseToSelectedOrderDetails(orderDetails),
      };
    });
  };

  const onDialogClose = () =>
    setUiState((draft) => {
      draft.selectedOrder = undefined;
    });

  const onPageRequested = (page: number) => setCurrentPage(page);

  return {
    uiState,
    actions: {
      onOrderClicked,
      onDialogClose,
      onPageRequested,
    },
  };
}
